export default class OperationsFiltersViewModel {
    isActive: boolean = false;
    site: string[] = [];
    channel: string[] = [];
    team: string[] = [];
    teamLeader: string[] = [];
    agentName: AgentNameViewModel[] = [];
    agentTypes: string[] = ['Live Agents'];
}

export class AgentNameViewModel {
    name = '';
    payrollNumber: number = 0;
}